import { AxiosError } from "axios";
import axios from "axios";
import { delayAndWait } from "healthex-common/utils";
import { getAnonymousUserId } from "../Logic/AuthManager";
export function apiConfig(params) {
    const defaultTransformResponses = axios.defaults.transformResponse
        ? axios.defaults.transformResponse instanceof Array
            ? axios.defaults.transformResponse
            : [axios.defaults.transformResponse]
        : [];
    return {
        headers: {
            "Content-Type": "application/json",
            "x-anonymous-user-id": getAnonymousUserId(),
        },
        params: params !== null && params !== void 0 ? params : {},
        transformResponse: [
            ...defaultTransformResponses,
            (data) => {
                if (data === "")
                    return null;
                return data;
            },
        ],
    };
}
export async function authenticatedApiConfig(authenticationProvider, params) {
    var _a;
    await ((_a = authenticationProvider.prepareAuthenticatedRequest) === null || _a === void 0 ? void 0 : _a.call(authenticationProvider));
    const config = apiConfig(params);
    const token = authenticationProvider.token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}
export function generateURL(baseUrl, path, parameters) {
    let fullUrl = baseUrl + path;
    if (parameters) {
        Object.entries(parameters).forEach(([param, value]) => {
            fullUrl = fullUrl.replace(`:${param}`, value.toString());
        });
    }
    return fullUrl;
}
export async function retryTooManyRequests(doRequest, retryLimit = 2) {
    var _a;
    try {
        return await doRequest();
    }
    catch (e) {
        console.log("Got exception", e);
        if (retryLimit === 0) {
            throw e;
        }
        if (e instanceof AxiosError && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 429 && e.response.headers["retry-after"]) {
            const secondsToWait = parseInt(e.response.headers["retry-after"]) + 5;
            console.log(`Received 429, waiting ${secondsToWait} seconds...`);
            await delayAndWait(secondsToWait * 1000);
            console.log(`Retrying now...`);
            return await retryTooManyRequests(doRequest, retryLimit - 1);
        }
        else {
            throw e;
        }
    }
}
